<div class="preview-panel ">
  <h2 class="sr-only" id="nodeDetailsLabel">Node properties</h2>
  <div class="d-flex justify-content-between pb-3" *ngIf="treeTaxonomyData && (showNavigation || showControls)">
    <h2 class="text-truncate" *ngIf="editNodePermission && showControls">
      <span [mathJax]="selectedNode && selectedNode.full_statement ? selectedNode.full_statement : ''"></span>
      <span [mathJax]="selectedNode && selectedNode.human_coding_scheme ? selectedNode.human_coding_scheme : ''"></span>
    </h2>
    <app-navigation-arrow [showNavigation]="showNavigation" [selectedNode]="selectedNode" [firstNode]="firstNode"
      [lastNode]="lastNode" [taxonomyData]="treeTaxonomyData" [isAllNode]="isAllNode"
      (nextClickEvent)="onTreeNavigateNextClick($event)" (previousClickEvent)="onTreeNavigatePreviousClick($event)">
    </app-navigation-arrow>
    <button class="btn btn-primary btn-md save ng-star-inserted" type="button" (click)="editNode()"
      [disabled]="preventEdit || !isEditable || invalidUrl" *ngIf="editNodePermission && showControls">Save</button>
  </div>

    <app-node-details
        #nodeDetailsComponent
        (formData)="onReceiveFormObj($event)"
        [isEditable]="isEditable"
        [showNodeType]="showNodeType"
        (formValidate)="onFormValidate($event)"
        (formObject)="onFormObject($event)"
        [view]="view"
        [viewLocation]="viewLocation"
        [isAllFieldFilled]="isAllFieldFilled"
        [nodetypeList]="nodetypeList"
        [selectedNodeType]="selectedNodeType"
        [showUserFriendlyPage]="showUserFriendlyPage"
        [templateSelected] = "templateSelected"
        (formGenerated)="setFlagEvent($event)">
    </app-node-details>

  <section name="updateitem" class="form-view" *ngIf="!blankNodeType">
    <!-- ASSOCIATION + LINKED NODES SECTION STARTS -->
    <ng-container *ngIf="selectedNode">
      <div class="group inputfrom associations col-lg-12 px-0"
        *ngIf="taxonomyData && showAssociation && associatedNodes">

        <!-- Accordian starts -->
        <app-accordion
            [currentTreeTab]="currentTreeTab"
            [showEmptyFields]="showEmptyFields"
            [accordionNo]="modal ? '4_modal' : 4"
            [title]="'associations &amp; linked nodes'"
            [expanded]="true"
            [dataLength]="combinedAssociationArr.length"
            [addModalId]="'add-association'"
            [showAddButton]="isEditable"
            (addButtonClickedEvent)="onAddAssociation();optionSelected('Add Association')">
          <ng-container class="accordion-content" *ngIf="associatedNodes">
            <div class="row" *ngFor="let item of associatedNodes">
              <div class="associations_type mt-2 px-3 col-12 border-bottom">

                <div class="row pb-1 associations_type_inner px-0">
                  <div class="col-12">
                    <p class="mb-0 font-bold text-pink">{{ item.key }}</p>
                  </div>
                </div>

                <div class="row pt-1 associations_type_inner px-0" *ngFor="let data of item.value">
                  <div class="col-4 font-bold">
                    <p class="mb-0">{{data.key}}</p>
                  </div>

                  <div class="col-8">
                    <div class="mb-2" *ngFor="let node of data.value;let $index = index">
                      <div class="row">
                        <div class="col-10">
                          <p class="font-bold mb-1" *ngIf="node.link_type === 'linked node'">{{node.link_type}}</p>
                          <div class="mb-0">
                            <span class="node_type">{{node.target_node.node_type_title}} : </span>
                            <a class="text-underline" target="_blank" *ngIf="isNodeOrUri(node.target_node)==='node'"
                              (click)="openInNewTab($event, node.target_node, node.item_association_id)"
                              href="{{navigateToTaxonomy(node.target_node, node.item_association_id)}}"
                              id="link_{{node.target_node.item_id}}_{{$index}}" rel="noopener"
                              [ngClass]="{'cursor-deny':navigateToTaxonomy(node.target_node, node.item_association_id) === ''}">
                              <ng-container
                                *ngIf="(node.target_node.human_coding_scheme || node.target_node.full_statement); else document">
                                <span
                                    class="human_coding"
                                    *ngIf="node.target_node.human_coding_scheme && node.target_node.human_coding_scheme.length >0"
                                    [innerHtml]="node.target_node.human_coding_scheme">
                                </span>
                                <span
                                    class="font-bold"
                                    *ngIf="node.target_node.human_coding_scheme && node.target_node.full_statement"> :
                                </span>
                                <span
                                    class="full_statement"
                                    *ngIf="node.target_node.full_statement && node.target_node.full_statement.length >0"
                                    [innerHtml]="node.target_node.full_statement">
                                </span>
                              </ng-container>
                              <ng-template #document>
                                <!--If node does not have human coding scheme or full statement, show document title-->
                                <span
                                    class="full_statement"
                                    *ngIf="node.target_node.document && node.target_node.document.document_title"
                                    [innerHtml]="node.target_node.document.document_title">
                                </span>
                              </ng-template>

                            </a>
                            <a class="text-underline" *ngIf="isNodeOrUri(node.target_node)==='uri'"
                              href="{{node.target_node.destination_node_url}}" target="_blank"
                              id="{{node.target_node.destination_node_url}}" rel="noopener">
                              <span class="font-bold">{{node.target_node.destination_node_url}}</span>
                            </a>
                            <div class="font-1x text-muted mb-0 row" *ngFor="let metadata of node.metadata">
                              <div class="pr-1 col-6">
                                {{metadata.name}}:
                              </div>
                              <div class="col-6">
                                {{ metadata.metadata_value ? (metadata.metadata_value).split('#||#')[0] : 'None'}}
                              </div>
                            </div>
                          </div>
                          <p class="mb-0 font-1x text-gray" *ngIf="node.description">({{ node.description }})</p>
                        </div>
                        <div class="col-2 text-right" *ngIf="node.link_type === 'association'">
                          <button type="button"
                            class="btn btn-icon tooltip top top-right position-relative d-inline-block"
                            data-tooltip="Delete association" *ngIf="deleteAssociationsPermission && isEditable"
                            (click)="deleteAssociation(node)" [attr.aria-label]="'Delete association'">
                            <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <!-- IsChildof end -->

              </div>
            </div>

          </ng-container>
        </app-accordion>
        <!-- Accordian end -->

      </div>
    </ng-container>
    <!-- ASSOCIATION + LINKED NODES SECTION ENDS -->

    <!--ADDITIONAL METADATA SECTION STARTS-->
    <div
        class="group inputfrom custom_metadata col-lg-12 px-0"
        *ngIf="taxonomyData && showAdditionalMetadata && addedAdditionalMetadata">
        <!-- Accordian starts -->
        <app-accordion
            [showEmptyFields]="showEmptyFields"
            [accordionNo]="modal ? '1_modal' : 1"
            [title]="'additional metadata'"
            [expanded]="selectedNode?.is_document !== 1 ? false : true"
            [dataLength]="addedAdditionalMetadata.length"
            [addModalId]="'addAdditionalMetadata'"
            [showAddButton]="createAdditionalMetadataPermission && isEditable"
            (addButtonClickedEvent)="onAddMetadata();optionSelected('Additional Metadata')">
            <ng-container
                class="accordion-content"
                *ngIf="addedAdditionalMetadata">
                <app-additional-metadata-details
                    *ngFor="let data of addedAdditionalMetadata"
                    [additionalMetadataData]="data"
                    [viewMode]="(createAdditionalMetadataPermission && isEditable)?'edit':'view'"
                    [isRightPanel]="false"
                    (editClicked)="onEditAdditionalMetadata($event)"
                    (deleteClicked)="onDeleteProjectResource($event, 'AdditionalMetadata')">
                </app-additional-metadata-details>
            </ng-container>
        </app-accordion>
        <!-- Accordian end -->
    </div>
    <!--ADDITIONAL METADATA SECTION ENDS-->

    <!--EXEMPLAR SECTION STARTS-->
    <div class="group inputfrom associations col-lg-12 px-0" *ngIf="taxonomyData && showExemplar && itemExemplars">
        <!-- Accordian starts -->
        <app-accordion
            [showEmptyFields]="showEmptyFields"
            [accordionNo]="modal ? '2_modal' : 2"
            [title]="'exemplars'"
            [expanded]="false"
            [dataLength]="itemExemplars.length"
            [addModalId]="'add-exemplar'"
            [showAddButton]="isEditable"
            (addButtonClickedEvent)="onAddButtonClick('EXP');optionSelected('Exemplar')">
            <ng-container
                class="accordion-content"
                *ngIf="itemExemplars">
                <app-exemplar-details
                    [viewLocation]="viewLocation"
                    *ngFor="let exemplar of itemExemplars;let $index=index"
                    [exemplarData]="exemplar"
                    [isRightPanel]="false"
                    [serialNo]="$index"
                    (editClicked)="false"
                    (deleteClicked)="onDeleteProjectResource($event, 'Exemplar')"
                    (previewClicked)="false"
                    (downloadClicked)="false"
                    [viewMode]="isEditable ?'edit':'readonly'"
                    [showDelete]="isEditable ?'true':''"
                    [option]="'Exemplar'"
                    [canPreview]="canPreview">
                </app-exemplar-details>
            </ng-container>
        </app-accordion>
        <!-- Accordian end -->
    </div>
    <!--EXEMPLAR SECTION ENDS-->

    <!--ASSET SECTION STARTS-->
    <div
        class="group inputfrom associations col-lg-12 px-0"
        *ngIf="taxonomyData && (showDocument) && itemAssets">
        <!-- Accordian starts -->
        <app-accordion
            [showEmptyFields]="showEmptyFields"
            [accordionNo]="modal ? '3_modal' : 3"
            [title]="'documents'"
            [expanded]="false"
            [dataLength]="itemAssets.length"
            [addModalId]="'add-exemplar'"
            [showAddButton]="isEditable"
            (addButtonClickedEvent)="onAddButtonClick('DOC');optionSelected('Document');">
            <ng-container class="accordion-content" *ngIf="itemAssets">
                <app-exemplar-details
                    *ngFor="let asset of itemAssets;let $index=index"
                    [exemplarData]="asset"
                    [serialNo]="$index"
                    [viewLocation]="viewLocation"
                    [isRightPanel]="false"
                    (editClicked)="false"
                    (deleteClicked)="onDeleteProjectResource($event, 'Document')"
                    (previewClicked)="false"
                    (downloadClicked)="false"
                    [viewMode]="isEditable ?'edit':'readonly'"
                    [showDelete]="isEditable ?'true':''"
                    [option]="'Document'"
                    [canPreview]="canPreview">
                </app-exemplar-details>
            </ng-container>
        </app-accordion>
        <!-- Accordian end -->
    </div>
    <!--ASSET SECTION ENDS-->
</section>


  <!--CUSTOM METADATA MODAL SECTION STARTS-->
  <app-additional-metadata *ngIf="taxonomyData && selectedNodeType && accessTocken" #additionalMetadataComponent
    [nodeDetails]="selectedNode" [node_type_id]="selectedNodeType['node_type_id']" [nodeType]="selectedNodeType"
    [option]="option" [addedMetadataList]="addedAdditionalMetadata" [hidden]="false"
    [selectedNodeId]="taxonomyData.item_id?taxonomyData.item_id:taxonomyData.id" [additionalMetadata]="fetchedMetadata"[viewLocation]="viewLocation"
    [action]="action" (deleteClicked)="onDeleteProjectResource($event, 'AdditionalMetadata')"></app-additional-metadata>

  <!--CUSTOM METADATA MODAL SECTION ENDS-->


  <app-association (assModalClosed)="assModalClosedEvent($event);"
    (associationCreateEvent)="onAssocationCreated($event)" #assocationModal
    *ngIf="taxonomyData && itemAssociations && accessTocken" [associationNode]="taxonomyData"
    [associationData]="itemAssociations" [originDocumentId]="taxonomyData.document_id" [projectId]="project_id">
  </app-association>


  <!-- Add Exemplar -->
  <app-add-exemplar [showModal]="showModal" *ngIf="taxonomyData && accessTocken"
    [selectedNodeId]="taxonomyData.item_id?taxonomyData.item_id:taxonomyData.id" [documentId]="taxonomyData.document_id"
    [itemExemplars]="option === 'Exemplar' ? itemExemplars : itemAssets" (addDeleteEvent)="onAddDelteExemplar()"
    [option]="option" [nodeDetails]="taxonomyData"></app-add-exemplar>

</div>